import { render, staticRenderFns } from "./sysdownload.vue?vue&type=template&id=0c76c695"
import script from "./sysdownload.vue?vue&type=script&lang=js"
export * from "./sysdownload.vue?vue&type=script&lang=js"
import style0 from "./sysdownload.vue?vue&type=style&index=0&id=0c76c695&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports